import { DomHelper } from "../general/utils";
import { breakpoints } from "../_variables";

class Navigation {

  static init () {
    Navigation.initMenuButton();
    Navigation.closeOnOutsideClick();
    Navigation.initFirstLevelNavigation();
  }

  static initMenuButton () {
    let menu = document.getElementById('main-navigation'),
        button = document.getElementById('menu-button');

    if(DomHelper.elementExists(menu)) {

      button.addEventListener('click', function () {

        if(menu.classList.contains('active')) {
          menu.classList.remove('active');
          DomHelper.enablePageScroll('has-overlay');
        } else {
          menu.classList.add('active');
          DomHelper.stopPageScroll('has-overlay');
          Navigation.setCurrentLevel();
        }
      });
    }
  }

  static closeOnOutsideClick () {
    let menu = document.getElementById('main-navigation');
    if(!menu) return;
    let overlay =menu.getElementsByClassName('navigation-overlay');

    // close on overlay click (mobile)
    if (overlay.length) {
      overlay[0].addEventListener('click', function () {
        if (menu.classList.contains('active')) {
          menu.classList.remove('active');
          DomHelper.enablePageScroll('has-overlay');
        }
      });
    }

    // close on content click (desktop)
    window.addEventListener('click', function(e) {
      if (!document.getElementsByTagName('header')[0].contains(e.target)) {
        if (menu.classList.contains('active')) {
          menu.classList.remove('active');
          DomHelper.enablePageScroll('has-overlay');
        }

        Navigation.closeSecondLevelMenus(null, null);
      }
    })
  }

  static setCurrentLevel () {
    let menu = document.getElementById('main-navigation'),
        activeSecondLevelEls = menu.querySelectorAll('nav > ul > li.sub > nav > ul li.current');

    if(activeSecondLevelEls.length) {
      for(let el of Array.from(activeSecondLevelEls)) {
        DomHelper.closest(el, 'nav').classList.add('active');
      }
    }
  }

  static initFirstLevelNavigation () {
    let menu = document.getElementById('main-navigation'),
        firstLevelItems = menu.querySelectorAll('nav > ul > li.sub');

    for(let item of Array.from(firstLevelItems)) {
      Navigation.handleFirstLevelClick(menu, item);
    }
  }

  static handleFirstLevelClick (menu, listitem) {
    let _scope = this,
        nav = menu.getElementsByClassName('navigation-wrapper')[0],
        el = listitem.firstElementChild,
        secondLevelMenu = listitem.getElementsByTagName('nav')[0];

    Navigation.handleBacklinkClick(nav, secondLevelMenu, el);

    el.addEventListener('click', function () {
      _scope.closeSecondLevelMenus(el, secondLevelMenu);

      if(secondLevelMenu.classList.contains('active')) {
        secondLevelMenu.classList.remove('active');
        el.classList.remove('clicked');
        nav.style.overflow = '';
      } else {
        secondLevelMenu.classList.add('active');
        el.classList.add('clicked');
        nav.style.overflow = 'hidden';

        Navigation.onResize();
      }
    });
  }

  static onResize () {
    let menu = document.getElementById('main-navigation'),
        activeSecondLevelMenus = menu.querySelectorAll('nav > ul > li.sub > nav.active');

    if(activeSecondLevelMenus.length) {

      for(let activeSecondLevelMenu of Array.from(activeSecondLevelMenus)) {
        let listitem = activeSecondLevelMenu.parentNode,
            el = listitem.firstElementChild;

        if(DomHelper.getWindowInnerWidth() >= breakpoints.breakpointsm) {
          activeSecondLevelMenu.style.left = (parseInt(el.getBoundingClientRect().left, 10) - 10) + 'px';
        } else {
          activeSecondLevelMenu.style.left = '';
        }
      }
    }
  }

  static closeSecondLevelMenus (clickedEl, clickedMenu) {
    let menu = document.getElementById('main-navigation'),
        listElemnts = menu.querySelectorAll('nav > ul > li.sub > span'),
        secondLevelMenus = menu.querySelectorAll('nav > ul > li.sub > nav');

    for(let listElemnt of Array.from(listElemnts)) {

      if(listElemnt.classList.contains('clicked') && (clickedEl !== listElemnt)) {
        listElemnt.classList.remove('clicked');
      }
    }

    for(let secondLevelMenu of Array.from(secondLevelMenus)) {

      if(secondLevelMenu.classList.contains('active') && (clickedMenu !== secondLevelMenu)) {
        secondLevelMenu.classList.remove('active');
      }
    }
  }

  static handleBacklinkClick (nav, menu, el) {
    let back = !!menu ? menu.querySelectorAll('.back-link')[0] : null;

    if(back !== null) {
      back.addEventListener('click', function () {
        if(menu.classList.contains('active')) {
          menu.classList.remove('active');
          el.classList.remove('clicked');
          nav.style.overflow = '';
        }
      });
    }
  }
}

export {
  Navigation
};